module.exports = __webpack_public_path__ + "static/media/unknown.50939118.png";